import { Injectable } from '@angular/core';
import { ApiAutoCompleteService, FieldSelectOption } from 'components';

import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

import { CodeWrapperService } from '../service-wrappers/code-wrapper.service';

@Injectable({
  providedIn: 'root'
})
export class StatementMessageLookupService extends ApiAutoCompleteService {
  codeKey = 'StatementMessage';
  constructor(private service: CodeWrapperService) {
    super();
  }

  statementMessagesEmpty$ = this.service
    .apiV1CodeCodetypePost('StatementMessage', {
      generalSearch: '',
      pageSize: 500
    })
    .pipe(shareReplay(1));

  mapRow(result) {
    return {
      value: result.id,
      label: `${result.code} - ${result.name}`
    };
  }

  search(value: string): Observable<FieldSelectOption[]> {
    if (value === '') {
      return this.statementMessagesEmpty$.pipe(map((results) => results.data.map(this.mapRow)));
    }
    return this.service
      .apiV1CodeCodetypePost(this.codeKey, {
        generalSearch: value
      })
      .pipe(map((results) => results.data.map(this.mapRow)));
  }

  load(id: string): Observable<FieldSelectOption> {
    if (id !== '') {
      return this.service.apiV1CodeCodetypeIdGet(this.codeKey, id).pipe(map(this.mapRow));
    }
  }
}
